<template>
  <el-table
    :data="tableData"
    border
    style="width: 100%"
    v-loading="loading"
  >
    <el-table-column
      prop="amount"
      :label="$t('accountWithdrawalApplyListManage.withdrawalAmount')"
      align="center"
    />
    <el-table-column
      prop="applyUserName"
      :label="$t('accountWithdrawalApplyListManage.applicantName')"
      align="center"
    />
    <el-table-column
      prop="applyUserTel"
      :label="$t('accountWithdrawalApplyListManage.applicantPhone')"
      align="center"
    />
    <el-table-column
      prop="context"
      :label="$t('accountWithdrawalApplyListManage.applicationDescription')"
      align="center"
    />
    <el-table-column
      prop="stateName"
      :label="$t('accountWithdrawalApplyListManage.status')"
      align="center"
    />
    <el-table-column
      prop="createTime"
      label="申请时间"
      align="center"
      width="180"
    />
  </el-table>
</template>

<script>
export default {
  name: 'AccountWithdrawalApplyListTable',
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['refresh'],
  created() {
    console.log('refresh');
  }
}
</script>